import { apiClient } from '../client';

export interface ApprovalMatrixRule {
  id: number;
  module: string;
  condition_type: 'amount_lt' | 'amount_gte' | 'amount_between' | 'project' | 'sector' | 'donor' | 'department';
  condition_value: string;
  approver_role: string;
  sequence: number;
  is_active: number;
  effective_date: string | null;
  priority: number;
}

export interface ApprovalMatrixInput {
  module: string;
  conditionType: ApprovalMatrixRule['condition_type'];
  conditionValue: string;
  approverRole: string;
  sequence: number;
  effectiveDate?: string | null;
  priority: number;
}

export interface PreviewResult {
  sequence: number;
  approverRole: string;
  matchedRule: { conditionType: string; conditionValue: string };
}

/** Real CRUD over the same approval_matrices table WorkflowEngine reads for every live approval - no separate config store. */
export const approvalMatrixApi = {
  list: (module?: string) => apiClient.get<{ data: ApprovalMatrixRule[] }>(`/api/admin/approval-matrices${module ? `?module=${encodeURIComponent(module)}` : ''}`),
  modules: () => apiClient.get<{ data: string[] }>('/api/admin/approval-matrices/modules'),
  get: (id: number) => apiClient.get<{ data: ApprovalMatrixRule }>(`/api/admin/approval-matrices/${id}`),
  create: (input: ApprovalMatrixInput) => apiClient.post<{ data: { id: number } }>('/api/admin/approval-matrices', input),
  update: (id: number, input: ApprovalMatrixInput) => apiClient.put<{ data: { id: number } }>(`/api/admin/approval-matrices/${id}`, input),
  duplicate: (id: number) => apiClient.post<{ data: { id: number } }>(`/api/admin/approval-matrices/${id}/duplicate`),
  activate: (id: number) => apiClient.post<{ data: { id: number; isActive: boolean } }>(`/api/admin/approval-matrices/${id}/activate`),
  deactivate: (id: number) => apiClient.post<{ data: { id: number; isActive: boolean } }>(`/api/admin/approval-matrices/${id}/deactivate`),
  preview: (input: { module: string; amount?: number; projectId?: number; sectorId?: number; donorId?: number; departmentId?: number }) =>
    apiClient.post<{ data: PreviewResult[] }>('/api/admin/approval-matrices/preview', input),
};
